/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Objects of type DeviceAlertMessage are sent to hub method named deviceAlertMessage in the device group device_<deviceId>. Listen to it via `signalRHub.on('deviceAlertMessage', (message: DeviceAlertMessage) => {}`
 * Message is forwarded directly from Service Bus - it's currently the same type
 * @export
 * @interface DeviceAlertMessage
 */
export interface DeviceAlertMessage {
    /**
     *
     * @type {string}
     * @memberof DeviceAlertMessage
     */
    alertType?: string;
    /**
     *
     * @type {Date}
     * @memberof DeviceAlertMessage
     */
    startTime?: Date;
    /**
     *
     * @type {number}
     * @memberof DeviceAlertMessage
     */
    durationSeconds?: number;
    /**
     *
     * @type {string}
     * @memberof DeviceAlertMessage
     */
    message?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceAlertMessage
     */
    derEventId?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceAlertMessage
     */
    deviceType?: DeviceAlertMessageDeviceTypeEnum;
    /**
     *
     * @type {string}
     * @memberof DeviceAlertMessage
     */
    deviceId?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceAlertMessage
     */
    timeToLive?: string;
    /**
     *
     * @type {Date}
     * @memberof DeviceAlertMessage
     */
    scheduledTime?: Date;
}

/**
 * @export
 */
export const DeviceAlertMessageDeviceTypeEnum = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;
export type DeviceAlertMessageDeviceTypeEnum =
    (typeof DeviceAlertMessageDeviceTypeEnum)[keyof typeof DeviceAlertMessageDeviceTypeEnum];

/**
 * Check if a given object implements the DeviceAlertMessage interface.
 */
export function instanceOfDeviceAlertMessage(
    value: object,
): value is DeviceAlertMessage {
    return true;
}

export function DeviceAlertMessageFromJSON(json: any): DeviceAlertMessage {
    return DeviceAlertMessageFromJSONTyped(json, false);
}

export function DeviceAlertMessageFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceAlertMessage {
    if (json == null) {
        return json;
    }
    return {
        alertType: json["alertType"] == null ? undefined : json["alertType"],
        startTime:
            json["startTime"] == null ? undefined : new Date(json["startTime"]),
        durationSeconds:
            json["durationSeconds"] == null
                ? undefined
                : json["durationSeconds"],
        message: json["message"] == null ? undefined : json["message"],
        derEventId: json["derEventId"] == null ? undefined : json["derEventId"],
        deviceType: json["deviceType"] == null ? undefined : json["deviceType"],
        deviceId: json["deviceId"] == null ? undefined : json["deviceId"],
        timeToLive: json["timeToLive"] == null ? undefined : json["timeToLive"],
        scheduledTime:
            json["scheduledTime"] == null
                ? undefined
                : new Date(json["scheduledTime"]),
    };
}

export function DeviceAlertMessageToJSON(
    value?: DeviceAlertMessage | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        alertType: value["alertType"],
        startTime:
            value["startTime"] == null
                ? undefined
                : value["startTime"].toISOString(),
        durationSeconds: value["durationSeconds"],
        message: value["message"],
        derEventId: value["derEventId"],
        deviceType: value["deviceType"],
        deviceId: value["deviceId"],
        timeToLive: value["timeToLive"],
        scheduledTime:
            value["scheduledTime"] == null
                ? undefined
                : value["scheduledTime"].toISOString(),
    };
}
